import { Button } from "../../Common/Button";
import { Card } from "../../Common/Card";
import Layout from "../../Common/Layout";
import Spacer from "../../Common/Spacer";
import StyledText from "../../Common/StyledText";

const ButtonDemoCard = () => {
	return (
		<Card variant="primary" title="Card test">
			<Spacer pt=".5em" pb=".5em">
				<Layout vertical gap="10px">
					<StyledText align="left">Testing out a card. Testing 123.</StyledText>
					<Layout responsive horizontal gap=".5em">
						<Button size="sm" variant="primary">
							Try Me
						</Button>
						<Button size="sm" variant="secondary">
							Try Me
						</Button>
						<Button size="sm" variant="info">
							Try Me
						</Button>
						<Button size="sm" variant="success">
							Try Me
						</Button>
						<Button size="sm" variant="warning">
							Try Me
						</Button>
						<Button size="sm" variant="danger">
							Try Me
						</Button>
					</Layout>
					<Layout responsive horizontal gap=".5em">
						<Button variant="primary">Try Me</Button>
						<Button variant="secondary">Try Me</Button>
						<Button variant="info">Try Me</Button>
						<Button variant="success">Try Me</Button>
						<Button variant="warning">Try Me</Button>
						<Button variant="danger">Try Me</Button>
					</Layout>
					<Layout responsive horizontal gap=".5em">
						<Button size="lg" variant="primary">
							Try Me
						</Button>
						<Button size="lg" variant="secondary">
							Try Me
						</Button>
						<Button size="lg" variant="info">
							Try Me
						</Button>
						<Button size="lg" variant="success">
							Try Me
						</Button>
						<Button size="lg" variant="warning">
							Try Me
						</Button>
						<Button size="lg" variant="danger">
							Try Me
						</Button>
					</Layout>

					<hr />
					<Layout responsive horizontal gap=".5em">
						<Button size="sm" outlined variant="primary">
							Try Me
						</Button>
						<Button size="sm" outlined variant="secondary">
							Try Me
						</Button>
						<Button size="sm" outlined variant="info">
							Try Me
						</Button>
						<Button size="sm" outlined variant="success">
							Try Me
						</Button>
						<Button size="sm" outlined variant="warning">
							Try Me
						</Button>
						<Button size="sm" outlined variant="danger">
							Try Me
						</Button>
					</Layout>
					<Layout responsive horizontal gap=".5em">
						<Button outlined variant="primary">
							Try Me
						</Button>
						<Button outlined variant="secondary">
							Try Me
						</Button>
						<Button outlined variant="info">
							Try Me
						</Button>
						<Button outlined variant="success">
							Try Me
						</Button>
						<Button outlined variant="warning">
							Try Me
						</Button>
						<Button outlined variant="danger">
							Try Me
						</Button>
					</Layout>
					<Layout responsive horizontal gap="1em">
						<Button size="lg" outlined variant="primary">
							Try Me
						</Button>
						<Button size="lg" outlined variant="secondary">
							Try Me
						</Button>
						<Button size="lg" outlined variant="info">
							Try Me
						</Button>
						<Button size="lg" outlined variant="success">
							Try Me
						</Button>
						<Button size="lg" outlined variant="warning">
							Try Me
						</Button>
						<Button size="lg" outlined variant="danger">
							Try Me
						</Button>
					</Layout>
				</Layout>
			</Spacer>
		</Card>
	);
};

export default ButtonDemoCard;
